export default {
  libs: [],
  books: [],
  basicBooks: [],
  lastBookResults: [],
  lastTxtSearch: "",
  wordAlt: {},
  FSwordAlt: {},
  noPrintBooks: [],
};
